import React from "react";
import type { TransformedProduct } from "../../../../types/productApiTypes";

interface ProductShortDescriptionProps {
  product: TransformedProduct;
  selectedVariation: TransformedProduct | null;
}

/**
 * Renders the product's short description, dynamically showing variation description when selected.
 */
const ProductShortDescription: React.FC<ProductShortDescriptionProps> = ({
  product,
  selectedVariation,
}) => {
  // Determine which description to show.
  // Priority: 1. Selected variation's description, 2. Parent product's description.
  const descriptionToShow =
    selectedVariation?.shortDescription || product.shortDescription;

  // Don't render the component if there's no description to show.
  if (!descriptionToShow) {
    return null;
  }

  return (
    <div
      className="product-info-details__description"
      dangerouslySetInnerHTML={{ __html: descriptionToShow }}
    />
  );
};

export default ProductShortDescription;
